
import { useState } from 'react';

interface ProductGalleryProps {
  images: string[];
  name: string;
}

export default function ProductGallery({ images, name }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex gap-4">
      <div className="flex flex-col gap-3">
        {images.map((img, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`w-20 h-20 rounded-md overflow-hidden border-2 transition-all cursor-pointer flex-shrink-0 ${
              activeIndex === index ? 'border-teal-500' : 'border-zinc-700 hover:border-zinc-500'
            }`}
          >
            <img src={img} alt={`${name} view ${index + 1}`} width="80" height="80" className="w-full h-full object-cover object-top" />
          </button>
        ))}
      </div>
      <div className="flex-1 w-full h-[520px] bg-zinc-900 rounded-lg overflow-hidden relative group">
        <img
          src={images[activeIndex]}
          alt={name}
          width="800"
          height="520"
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute bottom-4 right-4 flex gap-2">
          <button
            onClick={() => setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
            className="w-10 h-10 flex items-center justify-center bg-black/60 backdrop-blur-sm rounded-full hover:bg-black/80 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg text-white"></i>
          </button>
          <button
            onClick={() => setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))}
            className="w-10 h-10 flex items-center justify-center bg-black/60 backdrop-blur-sm rounded-full hover:bg-black/80 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg text-white"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
